"use client";

import { BottomNav } from "@/components/bottom-nav";

interface BottomNavWrapperProps {
  userType: "contractor" | "worker";
}

export function BottomNavWrapper({ userType }: BottomNavWrapperProps) {
  return <BottomNav userType={userType} />;
}
